<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">                
    <g clip-path="url(#clip0_231_711)">
        <path d="M17.8 15.4H9.4L4.6 19V15.4H2.2C1.88174 15.4 1.57652 15.2736 1.35147 15.0485C1.12643 14.8235 1 14.5183 1 14.2V2.2C1 1.88174 1.12643 1.57652 1.35147 1.35147C1.57652 1.12643 1.88174 1 2.2 1H17.8C18.1183 1 18.4235 1.12643 18.6485 1.35147C18.8736 1.57652 19 1.88174 19 2.2V14.2C19 14.5183 18.8736 14.8235 18.6485 15.0485C18.4235 15.2736 18.1183 15.4 17.8 15.4Z" stroke="#A7002D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.59961 5.79999C7.59969 5.36002 7.72072 4.92853 7.94947 4.55269C8.17821 4.17685 8.50587 3.87112 8.89663 3.66892C9.28739 3.46672 9.72622 3.37582 10.1651 3.40617C10.6041 3.43652 11.0262 3.58694 11.3854 3.84099C11.7447 4.09505 12.0271 4.44296 12.202 4.84671C12.3768 5.25045 12.4373 5.69449 12.3768 6.13029C12.3164 6.56609 12.1373 6.97689 11.8591 7.31778C11.5809 7.65867 11.2144 7.91654 10.7996 8.06319C10.5655 8.14595 10.3629 8.29926 10.2196 8.502C10.0764 8.70474 9.99948 8.94693 9.99961 9.19519V9.39999" stroke="#A7002D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.99922 12.4C9.91965 12.4 9.84335 12.3684 9.78709 12.3121C9.73083 12.2559 9.69922 12.1796 9.69922 12.1C9.69922 12.0204 9.73083 11.9441 9.78709 11.8879C9.84335 11.8316 9.91965 11.8 9.99922 11.8" stroke="#A7002D" stroke-width="1.5"/>
        <path d="M10 12.4C10.0796 12.4 10.1559 12.3684 10.2121 12.3121C10.2684 12.2559 10.3 12.1796 10.3 12.1C10.3 12.0204 10.2684 11.9441 10.2121 11.8879C10.1559 11.8316 10.0796 11.8 10 11.8" stroke="#A7002D" stroke-width="1.5"/>
    </g>
    <defs>
        <clipPath id="clip0_231_711">
            <rect width="20" height="20" fill="white"/>
        </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
